import Vue from 'vue'
export const AppHub = new Vue()
export const EmailHub = new Vue()
export const MessageHub = new Vue()
export const PullStatusHub = new Vue()
